var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-title',[_vm._v("PBX")]),(!_vm.sessId)?_c('pbx-login',{ref:"login",on:{"loggedIn":_vm.loggedIn}}):_vm._e(),(_vm.sessId)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('pbx-extensions',{ref:"extensions"})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }